import React from 'react';

import Lozenge from '@atlaskit/lozenge';

export default (): React.JSX.Element => <Lozenge appearance="information">Information</Lozenge>;
